module.exports = __webpack_public_path__ + "img/promptD.95cb10ce.png";